export default {
  sections: {
    payment: 'Pago',
  },
  labels: {
    proceed_to_payment: 'Procede al pago mediante enlace o escanea el código QR',
  },
  buttons: {
    generate_new_link: 'Generar nuevo enlace',
    copy_link: 'Copiar enlace',
    pay_now: 'Pagar ahora',
  },
  toasts: {
    failed_to_create_payment_link: 'Error al cargar el enlace de pago',
  },
};
